import React, { useEffect } from "react";
import {
  Card,
  CardContent,
  CardActionArea,
  CardActions,
  Typography,
} from "@mui/material";

import axios from "axios";
import { farmageo_api } from "../../../../config";

export default function Notificaciones({ configuraciones }) {
  const [notificaciones, setNotificaciones] = React.useState(
    configuraciones.notificaciones
  );

  useEffect(() => {
    setNotificaciones(configuraciones.notificaciones);
    if (configuraciones.notificaciones.length > 0) {
      axios
        .post(`${farmageo_api}/notificacion/visto`, {
          notificaciones: configuraciones.notificaciones,
        })
        .catch((error) => {
          console.error("Error fetching notifications:", error);
        });
    }
  }, [configuraciones.notificaciones]);

  if (
    notificaciones.length === 0 ||
    notificaciones.every((n) => n.mostrar === "n")
  )
    return <></>;

  const lindo = false;

  const handleAceptarNotificacion = (e, notificacion) => {
    e.preventDefault();
    e.stopPropagation();

    axios
      .post(`${farmageo_api}/notificacion/aceptar/${notificacion.id}`)
      .then(() => {
        handleDismissNotificacion(e, notificacion);
      })
      .catch((error) => {
        console.error("Error fetching notifications:", error);
      });
  };

  const handleDismissNotificacion = (e, notificacion) => {
    e.preventDefault();
    e.stopPropagation();

    setNotificaciones((prev) =>
      prev.map((n) => (n.id === notificacion.id ? { ...n, mostrar: "n" } : n))
    );
  };

  return (
    <Card sx={{ margin: "10px 0" }}>
      <CardContent>
        {/* <Typography gutterBottom variant="h5" component="div">
          Notificaciones{" "}
        </Typography> */}

        {lindo ? (
          notificaciones.map((notificacion, index) => (
            <Card sx={{ margin: "10px 0" }} key={notificacion.id ?? index}>
              <CardActionArea>
                <Typography style={{ margin: "10px 0" }}>
                  <div
                    dangerouslySetInnerHTML={{ __html: notificacion.texto }}
                  />
                </Typography>
              </CardActionArea>
              <CardActions />
            </Card>
          ))
        ) : (
          <div className="notificacion_wrap">
            <table className="notificacion_table">
              <thead style={{ display: "none" }}>
                <tr>
                  <th></th>
                </tr>
              </thead>

              <tbody className="notificacion_body">
                {notificaciones.map((notificacion) => {
                  if (notificacion.mostrar === "n") return null;
                  return (
                    <tr className="notificacion_tr" key={notificacion.id}>
                      <td className="notificacion_textTd">
                        <div className="notificacion_row">
                          <div
                            className="notificacion_texto"
                            dangerouslySetInnerHTML={{
                              __html: notificacion.texto,
                            }}
                          />
                          <div className="notificacion_actions_inline">
                            {notificacion.aceptable === "s" ? (
                              <button
                                className="btn-aceptar"
                                onClick={(e) =>
                                  handleAceptarNotificacion(e, notificacion)
                                }
                                title="Aceptar"
                              >
                                ✓ Aceptar
                              </button>
                            ) : null}
                            <button
                              className="btn-cerrar"
                              onClick={(e) =>
                                handleDismissNotificacion(e, notificacion)
                              }
                              aria-label="Cerrar"
                              title="Cerrar"
                            >
                              ×
                            </button>
                          </div>
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}
      </CardContent>
    </Card>
  );
}
